<template>
  <div
    class="fixed inset-0 bg-neutral-900/25 transition-opacity dark:bg-neutral-700/40"
  />
</template>
